// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"6b81c70d","154":"2ffbd950","274":"6e0ab059","280":"2f6aee6a","348":"e05c07b3","453":"8b334368","482":"3f25bf15","537":"0ea47061","611":"c8838279","658":"3371d721","815":"fe6956fd","967":"cf16d951"}[chunkId] + ".chunk.js";
};